/*
 * Copyright (c) Nexign, JSC, 2021-2024.
 */
/**
 * Page SubscriberId ManageNumber Tab component
 *
 * @author Yakov Gushchin
 * @author Ilya Baranchikov
 * @version 1.29.0
 * @since 1.12.0
 */

import { Skeleton } from '../../../../../components/common';
import { useSubscriberIdContext } from '../../../context';
import { ESubscriberIdActions } from '../../../types';
import SubscriberIdError from '../../SubscriberIdError';
import { useGetManageNumberMetaQuery } from '../store';
import ManageNumberLabels from './ManageNumberLabels';
import ManageNumberPosition from './ManageNumberPosition';
import ManageNumberRedirection from './ManageNumberRedirection';
import ManageNumberSimCard from './ManageNumberSimCard';
import { ManageNumberGeneralSkeleton } from './ManageNumberSkeleton';
import { ManageNumberStyled } from './styled/ManageNumberStyled';

const SubscriberIdManageNumber = () => {
    const { subscriberId } = useSubscriberIdContext();

    const { data, error, isFetching, isSuccess, refetch } = useGetManageNumberMetaQuery(subscriberId);

    if (error || (isSuccess && !data)) return <SubscriberIdError refetch={refetch} />;
    if (isFetching) return <Skeleton isLoading render={ManageNumberGeneralSkeleton} />;
    if (!data) return null;

    return (
        <ManageNumberStyled>
            <div className="manage-number__parameters">
                {data.actions?.includes(ESubscriberIdActions.labelShow) && <ManageNumberLabels />}
                {data.actions?.includes(ESubscriberIdActions.positionShow) && <ManageNumberPosition />}
                <ManageNumberSimCard />
            </div>
            {data.actions?.includes(ESubscriberIdActions.forwardingShow) && <ManageNumberRedirection />}
        </ManageNumberStyled>
    );
};

export default SubscriberIdManageNumber;
